import { render } from "./ShareBar.vue?vue&type=template&id=c362b84e&scoped=true"
import script from "./ShareBar.vue?vue&type=script&lang=js"
export * from "./ShareBar.vue?vue&type=script&lang=js"

import "./ShareBar.vue?vue&type=style&index=0&id=c362b84e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c362b84e"

export default script